import React from "react";
import { AsideMenuItem } from "./AsideMenuItem";
import { useSubscription } from "../../../../hooks/useSubscription";

export function AsideMenuMain() {
  const { isAgency } = useSubscription();
  return (
    <>
      {" "}
      <>
        <>
          <div className="menu-item">
            <h4 className="menu-content text-muted mb-0 fs-6 fw-bold text-uppercase">
            Menu
            </h4>
          </div>
          <AsideMenuItem to="/" title="Home" />
          {/* <AsideMenuItem to="/extended" title="Project Dashboard" /> */}
          {/* <AsideMenuItem to="/light" title="Create New Idea" /> */}
        </>
      
        <>
          <div className="menu-item mt-10">
            <h4 className="menu-content text-muted mb-0 fs-6 fw-bold text-uppercase">
            Account
            </h4>
          </div>
          <AsideMenuItem to="/profile/account" title="User Profile" />
          <AsideMenuItem to="/profile/subscription" title="Subscription" />
        </>
        
        {isAgency && (
          <>
            <div className="menu-item mt-10">
              <h4 className="menu-content text-muted mb-0 fs-6 fw-bold text-uppercase">
                Team
              </h4>
            </div>
            <AsideMenuItem to="/team" title="Team" />
          </>
        )}

        <>
          <div className="menu-item mt-10">
            <h4 className="menu-content text-muted mb-0 fs-6 fw-bold text-uppercase">
            Sign Out
            </h4>
          </div>
          <AsideMenuItem to="/profile/overview" title="Sign Out" />
        </>
    
      </>
    </>
  );
}
